import { productCategoryApi } from "../api";

const ProductCategoryService = {
    /**
     * Obtener todas las categorías.
     */
    getAll: async () => {
        try {
            const response = await productCategoryApi.fetchAll();
            return response.data;
        } catch (error) {
            throw error;
        }
    },

     /**
     * Obtener categorías activas para un menú desplegable.
     */
     getDropdown: async () => {
        try {
            const response = await productCategoryApi.fetchCustom('/dropdown');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Buscar categoría por nombre.
     */
    findByName: async (name: string) => {
        try {
            const response = await productCategoryApi.fetchCustom(`/search?name=${name}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crear una nueva categoría.
     */
    save: async (data: Object) => {
        try {
            const response = await productCategoryApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualizar una categoría existente.
     */
    update: async (id: number, name: string) => {
        try {
            const response = await productCategoryApi.modify(id, { name });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Activar o desactivar una categoría.
     */
    deactivate: async (id: number) => {
        try {
            const response = await productCategoryApi.patchCustom(`${id}/toggle-status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default ProductCategoryService;
